export const HEIGHT_UNIT = Object.freeze({
  IN: 1,
  CM: 2,
});

export const WEIGHT_UNIT = Object.freeze({
  LB: 1,
  KG: 2,
});

export const HEIGHT_UNIT_ITEMS = [
  { label: 'In', value: HEIGHT_UNIT.IN },
  { label: 'Cm', value: HEIGHT_UNIT.CM },
];

export const WEIGHT_UNIT_ITEMS = [
  { label: 'Lb', value: WEIGHT_UNIT.LB },
  { label: 'Kg', value: WEIGHT_UNIT.KG },
];

export default {
  HEIGHT_UNIT,
  WEIGHT_UNIT,
  HEIGHT_UNIT_ITEMS,
  WEIGHT_UNIT_ITEMS,
};
